import { render, staticRenderFns } from "./StatSupervisionUnit.vue?vue&type=template&id=35f60951&scoped=true"
import script from "./StatSupervisionUnit.vue?vue&type=script&lang=js"
export * from "./StatSupervisionUnit.vue?vue&type=script&lang=js"
import style0 from "./StatSupervisionUnit.vue?vue&type=style&index=0&id=35f60951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f60951",
  null
  
)

export default component.exports